module.exports = {"attached":"O :attribute já está anexado.","relatable":"O :attribute pode não estar associado a este recurso."};